module.exports = __webpack_public_path__ + "static/media/handschuhe.b9b89c96.jpg";